












































































































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { State, Mutation, Getter } from 'vuex-class';
import PolicyNotListedModal from '@/components/Modal/Mmic/PolicyNotListed.vue';
import Auth from '@/services/Auth';
// Components
import SelectField from '@/components/Form/SelectField.vue';
import TextField from '@/components/Form/TextField.vue';
import RadioField from '@/components/Form/RadioField.vue';

import jQuery from 'jquery';
import { PolicyUi, Risk } from '@/common/Policy';
import Brand from '@/services/Brand';
import { PolicyDetails, User } from '@/common/Users';

@Component({
	name: 'InsuredsPolicyInformationFields',
	components: {
		SelectField,
		TextField,
		RadioField,
		PolicyNotListedModal,
	},
})
export default class InsuredsPolicyInformationFields extends Vue {
	private Brand = Brand.getBrand();
	@Prop() private values: any;
	@Prop() private input: any;
	@Prop() private blur: any;
	@Prop() private errors: any;
	@Prop() private touched: any;
	private Auth: any = Auth;
	@Getter('coreUser', { namespace: 'Auth' }) private coreUserRecord: User;
	@State('policies', { namespace: 'Policy' }) private policies: PolicyUi[];

	@Watch('values.insuredsPolicyInformation.policyNumber')
	private watchPolicyNumber(newPolicyNumber: string): void {
		const policy: PolicyUi | undefined = newPolicyNumber
			? this.policies.find(
					(policy: PolicyUi): boolean => policy.policy_number === newPolicyNumber,
			  )
			: undefined;
		if (policy) {
			this.values.insuredsPolicyInformation.nameOfInsured = policy.policy_holder.full_name;
		}
	}

	private mounted() {
		jQuery('[data-toggle="popover"]').popover();
	}
	private showModal() {
		jQuery('#notListed')
			.appendTo('body')
			.modal('show');
	}
	private login() {
		this.$router.push({
			name: 'login',
		});
	}

	private getDropDownName(policy: PolicyUi): string {
		try {
			const isAccountAdmin = Auth.checkPermission('ACCOUNT_ADMIN');
			const allUserPolicies = this.coreUserRecord?.policies;
			const userPolicies = allUserPolicies?.[this.Brand];
			if (userPolicies.length < 1 && !isAccountAdmin) {
				return;
			}
			return policy.dropDownPolicyHolderName;
		} catch (e) {
			console.log(e);
			return policy.dropDownPolicyHolderName;
		}
	}
}
